import { createAction } from 'redux-actions';

import dynaForms from '@elab/core/utils/dynaForms';

import getTypes from './types';

const createActions = storeName => {
    const types = getTypes(storeName);
    const hideGuestCheckout = createAction(types.HIDE_GUEST_CHECKOUT);
    const setFormIsLoaded = createAction(types.SET_FORM_IS_LOADED);
    const setCustomerLoyaltyStatus = createAction(types.SET_CUSTOMER_LOYALTY_STATUS);
    const setAuthOption = createAction(types.SET_AUTH_OPTION);
    const setIsPinCodeOrDOBValid = createAction(types.SET_IS_PIN_CODE_OR_DOB_VALID);
    const showPincode = createAction(types.SHOW_PINCODE);
    const phoneDobReceived = createAction(types.PHONE_DOB_RECEIVED);
    const disableStep1Button = createAction(types.DISABLE_STEP1_BUTTON);
    return {
        ...dynaForms.getActions(storeName),
        hideGuestCheckout,
        setFormIsLoaded,
        setCustomerLoyaltyStatus,
        setAuthOption,
        setIsPinCodeOrDOBValid,
        showPincode,
        phoneDobReceived,
        disableStep1Button,
    };
};

export default createActions;
